import { nvStorage } from '@simwood/nv-react-components';

interface Store {
  getState: () => {
    branding: {
      apiRoot: string;
      branding?: {
        loginRedirectUrl?: string;
      };
    };
    user: { accessToken?: string };
  };
}

let store: Store;

export const initNvFetch = (s: Store) => {
  store = s;
};

export const restAPIBase = () => {
  const storeApiBase = store?.getState()?.branding?.apiRoot;
  if (process.env.NODE_ENV === 'development') {
    return 'https://pbx.sipcentric.com/api/v1';
    // return 'http://dev.voip123.co.uk:8081/api/v1';
  }
  if (!storeApiBase) {
    return 'https://pbx.sipcentric.com/api/v1';
    // return 'http://dev.voip123.co.uk:8081/api/v1';
  }

  return `${storeApiBase}/api/v1`;
};

export const nvFetch = (
  endpoint: string,
  options: {
    headers?: Record<string, string>;
    token?: string;
    params?: Record<string, string | number | boolean>;
    method?: string;
    body?: string;
  } = {},
) => {
  const url = restAPIBase() + (endpoint.startsWith('/') ? '' : '/') + endpoint;
  const token = options.token || store.getState().user.accessToken;
  const loginRedirectUrl = store.getState().branding.branding?.loginRedirectUrl;

  const fetchOptions: RequestInit = {
    method: options.method,
    body: options.body,
  };
  fetchOptions.headers = options.headers || {};
  fetchOptions.headers['X-Relationship-Key'] = 'id';
  fetchOptions.headers['X-WWW-Authenticate'] = 'false';

  if (options.body) {
    fetchOptions.headers['Content-Type'] = 'application/json';
  }

  if (typeof token !== 'string') {
    return fetch(url, fetchOptions);
  }

  if (!loginRedirectUrl) {
    fetchOptions.headers.Authorization = `Bearer ${token}`;
  } else {
    fetchOptions.credentials = 'include';
  }

  const { params } = options;
  let completeUrl = url;

  if (params) {
    // Build query param string
    const queryString = Object.keys(params)
      .reduce((prev, key) => {
        const value = params[key];
        return `${prev}${key}=${value}&`;
      }, '?')
      .slice(0, -1);

    completeUrl += queryString;
  }

  return fetch(completeUrl, fetchOptions).then((res) => {
    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`);
    }
    return res;
  });
};

export const clearAuthToken = () => {
  nvStorage.remove('token');
  nvStorage.remove('token-remember');
  nvStorage.remove('token-expires');
};
